import React, { useEffect, useState, useMemo } from 'react'
import { addTeamApi, getSingleAdminApi, updateSingleAdminApi } from "../../api/usersApi";

const AddTeam = ({ isOpen, onClose, title, description, ref, setShowAddTeamPopup, setShowNotification, setNotificationMessage, teamApi, setTeamList, setFirstName, name, setLastName, lastName, setEmail, email, setPassword, password, isEdit, isSaveLoading, setIsSaveLoading, setTotalPage, updateData }) => {

    const [errorMessage, setErrorMessage] = useState({
        name: '',
        lastName: '',
        email: '',
        password: '',
        alreadyUsedEmail: '',
        validEmail: '',
    });
    const [changeName, setChangeName] = useState('');
    const [changeLastName, setChangeLastName] = useState('');
    const [changeEmail, setChangeEmail] = useState('');
    const [changePassword, setChangePassword] = useState('');


    const emailPattern = /^[^@\s]+@ivycorn\.[^@\s]+$/;

    useEffect(() => {
        if (isOpen) {
            setChangeName(name || '');
            setChangeLastName(lastName || '');
            setChangeEmail(email || '');
            setChangePassword(password || '');
        }
    }, [isOpen, name, lastName, email, password]);

    if (!isOpen) return null;

    const addTeam = async () => {
        let success = false;
        setIsSaveLoading(false);
        try {
            setIsSaveLoading(true);
            success = await addTeamApi({
                name: changeName,
                lastName: changeLastName,
                email: changeEmail,
                password: changePassword,
                role: 'ADMIN'
            });
            if (success) {
                const data = await teamApi();
                if (data) {
                    setTeamList(data?.list)
                    setTotalPage(data?.totalPage)
                    setShowAddTeamPopup(false);
                    setShowNotification(true);
                    setNotificationMessage(`${changeName} ${changeLastName} has been added to the team.`)
                    setTimeout(() => {
                        setShowNotification(false)
                    }, 8000)
                    setIsSaveLoading(false)
                }
            } else {
                setIsSaveLoading(false)
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message;
            if (errMsg?.toLowerCase().includes("email")) {
                setErrorMessage((prev) => ({
                    ...prev,
                    alreadyUsedEmail: errMsg,
                }));
            }
            setIsSaveLoading(false);
            return false;
        }
    }

    const handleAddTeam = async () => {
        let isValid = true;

        const newErrors = {
            name: '',
            lastName: '',
            email: '',
            password: '',
            validEmail: '',
        };
        if (!changeName?.trim()) {
            newErrors.name = 'Please fill first name.';
            isValid = false;
        }
        if (!changeLastName?.trim()) {
            newErrors.lastName = 'Please fill last name.';
            isValid = false;
        }
        if (!changeEmail?.trim()) {
            newErrors.email = 'Please fill email address.';
            isValid = false;
        }
        if (changeEmail?.length > 0) {
            if (!emailPattern?.test(changeEmail)) {
                newErrors.validEmail = 'Email address must be an Ivycorn email.';
                isValid = false;
            }
        }
        if (!changePassword?.trim()) {
            newErrors.password = 'Please fill password.';
            isValid = false;
        }
        setErrorMessage(newErrors);
        if (!isValid) return;

        if (isEdit) {
            await updateData({ changeName, changeLastName, changeEmail, changePassword, setErrorMessage });
        } else {
            await addTeam();
        }
    }

    return (
        <div className="popup-overlay setting-addTeam-popup" >
            <div className="popup-box" ref={ref}>
                <div className='popup-top-content'>
                    <div className="popup-close" onClick={onClose}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className='popup-content'>
                        <div className='popup-title'>{title}</div>
                        <p className="description">
                            {description}
                        </p>
                        <p className="warning">
                            This action is irreversible, so please confirm if you’re sure.
                        </p>
                    </div>
                    <div className="name-block">
                        <div className="team-name-block">
                            <div className={`input-group ${changeName ? 'filled' : ''} ${errorMessage?.name ? 'show-error update-input-group' : ''}`}>
                                <input type="text" id='name' className='' autoComplete="off" name='name' value={changeName} onChange={(e) => {
                                    setChangeName(e.target.value);
                                    if (errorMessage?.name) {
                                        setErrorMessage(prev => ({ ...prev, name: '' }));
                                    }
                                }} />
                                <label className="update-input-label" htmlFor="name">First name</label>
                                {errorMessage?.name && (
                                    <p className="error-message update-input-error">{errorMessage?.name}</p>
                                )}
                            </div>
                            <div className={`input-group ${changeLastName ? 'filled' : ''} ${errorMessage?.lastName ? 'show-error update-input-group' : ''}`}>
                                <input type="text" id='lastName' className='' autoComplete="off" name='lastName' value={changeLastName} onChange={(e) => {
                                    setChangeLastName(e.target.value)
                                    if (errorMessage?.lastName) {
                                        setErrorMessage(prev => ({ ...prev, lastName: '' }));
                                    }
                                }} />
                                <label className="update-input-label" htmlFor="lastName">Last name</label>
                                {errorMessage?.lastName && (
                                    <p className="error-message update-input-error">{errorMessage?.lastName}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={`input-group ${changeEmail ? 'filled' : ''} ${errorMessage?.email ? 'show-error update-input-group' : ''}`}>
                        <input type="email" id='email' className='' name='email' autoComplete="off" value={changeEmail} onChange={(e) => {
                            setChangeEmail(e.target.value)
                            if (errorMessage?.email || errorMessage?.alreadyUsedEmail || errorMessage?.validEmail) {
                                setErrorMessage(prev => ({ ...prev, email: '', alreadyUsedEmail: '', validEmail: '' }));
                            }
                        }} />
                        <label htmlFor="email">Email address</label>
                        {errorMessage?.email && (
                            <p className="error-message update-input-error">{errorMessage?.email}</p>
                        )}
                        {errorMessage?.alreadyUsedEmail && (
                            <p className="error-message update-input-error">{errorMessage?.alreadyUsedEmail}</p>
                        )}
                        {errorMessage?.validEmail && (
                            <p className="error-message update-input-error">{errorMessage?.validEmail}</p>
                        )}
                    </div>
                    <div className={`input-group ${changePassword ? 'filled' : ''} ${errorMessage?.password ? 'show-error update-input-group' : ''}`}>
                        <input type="password" id='password' className='' name='password' autoComplete="new-password" value={changePassword} onChange={(e) => {
                            setChangePassword(e.target.value)
                            if (errorMessage?.password) {
                                setErrorMessage(prev => ({ ...prev, password: '' }));
                            }
                        }} />
                        <label htmlFor="password">Password</label>
                        {errorMessage?.password && (
                            <p className="error-message update-input-error">{errorMessage?.password}</p>
                        )}
                    </div>
                </div>
                <div className="button-row">
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button
                        className={`suspend-btn add-team-btn button ${isSaveLoading ? 'btn_loading' : ''
                            }`}
                        onClick={() => { handleAddTeam(); }}
                    >
                        {isSaveLoading ? (
                            <div className="registerLoader">
                                <div className="ring-loader"></div>
                            </div>
                        ) : (
                            isEdit ? 'Save' : 'Add'
                        )}
                    </button>
                </div>
            </div>
        </div >
    )
}

export default AddTeam